import { render, staticRenderFns } from "./default_v2.vue?vue&type=template&id=2dca6db8&scoped=true"
import script from "./default_v2.vue?vue&type=script&setup=true&lang=ts"
export * from "./default_v2.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./default_v2.vue?vue&type=style&index=0&id=2dca6db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca6db8",
  null
  
)

export default component.exports